/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from 'axios'
import i18next from 'i18next'
import React, {useCallback, useEffect, useState} from 'react'
import {Spinner} from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Row from 'react-bootstrap/Row'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router-dom'
import swal from 'sweetalert'
import {KTSVG} from '../../../_metronic/helpers'
import {getAccessSo} from '../../../api/modules/approval/approval'
import {create, deleteFile, getFile} from '../../../api/modules/file'
import {getProvince, getSalesAreaLetter} from '../../../api/modules/getdatalist'
import {getCommentSO} from '../../../api/modules/so'
import Pagination from '../component/Pagination'
import AddRemoveJadwal from '../si/AddRemoveJadwal'
import {RowHeadTableSO} from './RowHeadTableSO'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {resetFilter, setNumberUrls, setSoOrders, soSelector} from '../../../redux/slices/soSlices'
import {RowFilterTableSO} from './RowFilterTableSO'
import ButtonGroupsTableSO from './ButtonGroupsTableSO'
import {PopoverText} from '../../../components/Popover/Popover'
import {fetchSOApproval, headers} from '../../../services/fetcher'
import {objToParams} from '../../../utils/objToParams'
import {DocFlow} from '../../../components/DocFlow'
import {getRoleFlagList} from '../../../api/modules/master-data/master_2'
import {MultiSelect} from 'react-multi-select-component'
import * as TableUI from '../../../components/Table/Table'
import {useRowTable} from '../../../hooks/useRowTable'
import {StyledCard} from '../../../components/StyledCard'
import {PriceFormater} from '../../../components/mikro/PriceFormater'
import {appSelector} from '../../../redux/slices/appSlices'
import {HakAkses} from '../../../components/mikro/getHakAkses'
import {authSelector} from 'src/redux/slices/authSlices'
import {BadgeColorSO} from 'src/components/BadgeColorSO'
import dateformat from 'src/utils/dateformat'
import {FieldProductSpec} from 'src/components/FieldProductSpec'
import {CheckSameIDAttachment} from 'src/components/mikro/CheckSameIDAttachment'
import { InputFile } from 'src/app/components/InputFile'
import { handleDownloadAttachment } from 'src/app/helpers/file'

type Props = {
  className: string
}

const ApprovalTableSO: React.FC<Props> = ({className}) => {
  const navigate = useNavigate()
  const [tooltip, setTooltip] = useState('Open')
  const {roleId} = useAppSelector(authSelector)
  const {filter, sort} = useAppSelector(soSelector)
  const dispatch = useAppDispatch()

  const hakAkses = HakAkses()
  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 16,
    onReloadTable: () => handleReloadTable(),
  })

  const handleOpen = (e: any) => {
    const icon = e.target
    if (icon.classList.contains('iconArow')) {
      icon?.classList.remove('iconArow')
      icon?.classList.add('iconArowOpen')
      setTooltip('Close')
    } else {
      icon?.classList.remove('iconArowOpen')
      icon?.classList.add('iconArow')
      setTooltip('Open')
    }
    const target = e.currentTarget.getAttribute('data-target')
    const fold = document.getElementById(target)
    fold?.classList.toggle('fold-open')
  }

  const [showUpload, setShowUpload] = useState(false)
  const {t} = useTranslation()
  const [btnLoading, setBtnLoading] = useState(false)

  //#region
  const [SOData, setSOData] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const [isFailed, setIsFailed] = useState(false)
  const [numberURL, setNumberURL] = useState([])
  const [ppn, setPPN] = useState<any[]>([])
  const [files, setFiles] = useState({file: null})
  const [allFile, setAllFiles] = useState<any[]>([])
  const [namaFile, setNamaFile] = useState('')
  const [description, setDescription] = useState('')
  const [isPrivate, setIsPrivate] = useState(false)
  const [dataType, setDataType] = useState('')
  const [province, setProvince] = useState([])
  const [idItem, setIDItem] = useState(0)
  const [param, setParam] = useState('')
  const [showJadwal, setShowJadwal] = useState(false)
  const [orderSubID, setOrderSubID] = useState(0)
  const [tipeProduct, setTipeProduct] = useState('')
  const [unitProduct, setUnitProduct] = useState('')
  const [SONumber, setSONumber] = useState('')
  const [fullcomment, setFullComment] = useState<any[]>([])
  const [showCommentCust, setShowCommentCust] = useState(false)
  const [tempDetail, setTempDetail] = useState<any>([])
  const [showDetail, setShowDetail] = useState(false)
  const [tempRole, setTempRole] = useState<any[]>([])
  const [fullRole, setFullRole] = useState<any[]>([])
  const [fileBox, setFileBox] = useState<any>({})
  //#endregion

  const clearInputUpload = () => {
    const inputfile = document.getElementById('upload') as HTMLInputElement
    inputfile.value = ''
    const input2 = document.getElementById('upload') as HTMLInputElement
    input2.value = ''
    const inputPrivate = document.getElementById('isPrivate') as HTMLInputElement
    inputPrivate.checked = false
  }

  const removeFileState = () => {
    setFiles({file: null})
    setNamaFile('')
    setDescription('')
    setDataType('')
  }

  const deleteAttachment = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    }).then(async (del) => {
      if (del) {
        await deleteFile(id)
          .then(() => {
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
            ambilAttachment(idItem, param)
          })
          .catch((error) => {
            swal({
              title: error.response.data,
              icon: 'error',
            })
          })
      }
    })
  }

  const handleUpload = async (id: any) => {
    setBtnLoading(true)
    let file = files.file
    let formdata = new FormData()
    let temparray: any[] = []
    if (tempRole.length > 0) {
      tempRole.forEach((data: any) => {
        temparray.push(data.value)
      })
    }
    formdata.append('file_r', file!)
    formdata.append('name', namaFile!)
    formdata.append('description', description!)
    formdata.append('attach_parent', id!)
    formdata.append('file_type', dataType)
    formdata.append('private', isPrivate.toString())
    formdata.append('credentials', localStorage.getItem('credential')!)
    formdata.append('roles', JSON.stringify(temparray))
    // if(param == 'order-item' && sektorId != 2){
    // formdata.append('unique_number', SONumber)
    // formdata.append('unique_flag', 'new_so_osd')
    // }
    // console.log(formdata)
    await create(param, formdata)
      .then((res) => {
        setNamaFile('')
        setDescription('')
        setDataType('')
        setIsPrivate(false)
        setFiles({file: null})
        ambilAttachment(id, param)
        removeFileState()
        clearInputUpload()
        swal({
          title: `${t('document uploaded successfully')}`,
          icon: 'success',
        })
      })
      .catch((error) => {
        swal({
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => setBtnLoading(false))
  }

  const ambilAttachment = async (id: any, paramm: any) => {
    const res = await getFile(paramm, id, localStorage.getItem('credential')!)
    setAllFiles(res.data.data)
  }

  const handleShowAttachment = (data: any) => {
    let tmp: any[] = []
    let idUser = localStorage?.getItem('user-id')
    data.forEach((item: any) => {
      if (item.private) {
        if (hakAkses?.attachment) {
          return tmp.push(item)
        } else if (idUser == item.user_id) {
          return tmp.push(item)
        } else {
        }
      } else {
        return tmp.push(item)
      }
    })
    setAllFiles(tmp)
  }

  const [roleUser, setRoleUser] = useState('')

  const [language, setLanguage] = useState<any>()

  useEffect(() => {
    const interval = setInterval(() => {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split('~#~').shift()
      }
      let language = getCookie('i18next')
      setLanguage(language)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const onFetchSOApproval = useCallback(() => {
    setLoading(true)
    setIsFailed(false)

    const checked = sort?.checked ? '-approved' : ''

    fetchSOApproval(checked, filter)
      .then((res) => {
        setSOData(res.data.data.data)
        dispatch(setSoOrders(res.data.data.data))
        setNumberURL(res.data.data.links)
        dispatch(setNumberUrls(res.data.data.links))
      })
      // .catch((err) => {
      //   swal({title: err.message, icon: 'error'})
      //   setIsFailed(true)
      // })
      .finally(() => {
        setLoading(false)
      })
  }, [dispatch, filter, sort?.checked])

  const dateFormatting = (date: any) => {
    if (date == null) return ''
    else {
      let today = new Date(date)
      let dd = String(today.getDate()).padStart(2, '0')
      let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
      let yyyy = today.getFullYear()
      return dd + '-' + mm + '-' + yyyy
    }
  }

  const [accesses, setAccesses] = useState<any>()
  const [salesOrg, setSalesOrg] = useState<any>()
  const [sektorId, setSektorId] = useState(0)
  const [provinceName, setProvinceName] = useState('')
  const [cityName, setCityName] = useState('')
  const [productName, setProductName] = useState('')
  const [requestQuantum, setReqeustQuantum] = useState('')
  const [fixedQuantum, setFixedQuantum] = useState('')

  const formattingTon = (ton: any) => {
    let tempTon = parseFloat(ton)
    let temp = ''
    if (i18next.language == 'en') {
      temp = tempTon.toLocaleString('en', {maximumFractionDigits: 4})
    } else {
      temp = tempTon.toLocaleString('id', {maximumFractionDigits: 4})
    }

    setFixedQuantum(temp)
  }

  useEffect(() => {
    const ProvinceData = async () => {
      await getProvince().then((res) => {
        setProvince(res.data.data)
      })
    }

    const role = () => {
      const role: any = localStorage.getItem('role-flag')
      setRoleUser(role)
    }

    const getAccessMenu = async () => {
      setLoading(true)
      const res = await getAccessSo(roleId)

      setAccesses(res.data.data)
    }

    const getSalesOrg = async () => {
      const res = await getSalesAreaLetter()

      setSalesOrg(res.data.data)
    }

    const getAllRoleList = async () => {
      const res = await getRoleFlagList()
      setFullRole(res.data.data)
    }

    getSalesOrg()
    getAccessMenu()
    ProvinceData()
    role()
    getAllRoleList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  const paginateNumber = async (url: string) => {
    if (!url) return
    setLoading(true)

    const credentials = localStorage.getItem('credential') as string
    const token = localStorage.getItem('token') as string
    const endpoint = `${url}&credentials=${credentials}&${objToParams(filter)}`
    const res = await axios.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})

    setSOData(res.data.data.data)
    setLoading(false)
    setNumberURL(res.data.data.links)

    dispatch(setSoOrders(res.data.data.data))
    dispatch(setNumberUrls(res.data.data.links))
  }

  const goToDetail = (id: any) => {
    navigate(`/approval/sales-order/detail/${id}`)
  }

  const handleCheckFile = (url: any) => {
    axios
      .get(url)
      .then((response) => {
        window.open(url)
      })
      .catch((error) => {
        swal({
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
  }

  const toDownloadSO = (id: any, cond: any) => {
    const lang = i18next.language
    if (cond == 'sap')
      handleCheckFile(
        `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/sales-order/print/so/${id}?lang=${
          i18next.language
        }&token=${localStorage.getItem('token')}`
      )
    else if (cond == 'booking')
      handleCheckFile(
        `${
          process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT
        }/sales-order/print/booking_code/${lang}/${id}?token=${localStorage.getItem('token')}`
      )
  }

  const handleReloadTable = () => {
    dispatch(resetFilter())
    onFetchSOApproval()
  }

  const handleGetComment = async (id: any) => {
    await getCommentSO(id).then((res) => {
      // console.log(res.data.data)
      setFullComment(res.data.data)
      setShowCommentCust(true)
    })
  }

  const handleShowValue = (enduser: any) => {
    let temparray: any[] = enduser.split(',')
    let temp = ''
    temparray.forEach((element: any, index: any) => {
      if (index + 1 == temparray.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  useEffect(() => {
    const getData = setTimeout(() => onFetchSOApproval(), 1000)
    return () => clearTimeout(getData)
  }, [onFetchSOApproval])

  useEffect(() => {
    return () => {
      handleReloadTable()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function handleShowRoleName(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  return (
    <StyledCard>
      <ButtonGroupsTableSO />

      <TableUI.TableWrapper>
        <TableUI.Table>
          <TableUI.THead>
            <RowHeadTableSO />
          </TableUI.THead>
          <TableUI.TBody>
            <RowFilterTableSO />
            {loading ? (
              <RowLoader />
            ) : isFailed ? (
              <RowErrorFetch />
            ) : SOData.length === 0 ? (
              <RowEmptyData />
            ) : (
              SOData.map((item, _index) => (
                <>
                  <tr>
                    <td>
                      <div className='d-flex justify-content-center align-items-center'>
                        <button
                          className='iconArow d-flex justify-content-center align-items-center me-2'
                          data-target={'target' + item['id']}
                          title={t(tooltip)}
                          onClick={handleOpen}
                        ></button>
                        <p>{item['id']}</p>
                      </div>
                    </td>
                    <td>
                      <span
                        className='fw-semibold cursor-pointer'
                        style={{color: '#274070'}}
                        onClick={() => goToDetail(item['id'])}
                      >
                        13{item['so_number']}
                      </span>
                    </td>
                    <td>
                      <span>
                        <PopoverText
                          content={
                            item['customer']?.title == null || item['customer']?.title == ''
                              ? item['customer']?.name
                              : item['customer']?.title + ' ' + item['customer']?.name
                          }
                          index={_index}
                          className='desc-slicee'
                        />
                      </span>
                    </td>
                    <td>
                      <span>10{item?.order_sub?.po_number}</span>
                    </td>
                    {item?.sector_id == 2 ? (
                      <td>
                        <span>{item?.sip_order?.SIP_number ? `11${item?.sip_order?.SIP_number}` : '-'}</span>
                      </td>
                    ) : (
                      <td>
                        <span>{item?.contract?.sip_order?.SIP_number ? `11${item?.contract?.sip_order?.SIP_number}` : '-'}</span>
                      </td>
                    )}
                    <td>
                      {item.sap_number == null && item.status == 6 && item.status == 7 ? (
                        <span>-</span>
                      ) : (
                        <span
                          className='fw-semibold cursor-pointer'
                          style={{color: '#274070'}}
                          onClick={() => toDownloadSO(item.id, 'sap')}
                        >
                          {item['sap_number']}
                        </span>
                      )}
                    </td>
                    <td>
                      {item.booking_code == null ? (
                        <span>-</span>
                      ) : (
                        <span
                          className='fw-semibold cursor-pointer'
                          style={{color: '#274070'}}
                          onClick={() => toDownloadSO(item.id, 'booking')}
                        >
                          {item.booking_code}
                        </span>
                      )}
                    </td>
                    <td>
                      <span>{item['anper']?.name}</span>
                    </td>
                    <td>
                      <span>{t(item.sector?.name)}</span>
                    </td>
                    <td>
                      {!item?.create_so_sap_date ? (
                        <span>-</span>
                      ) : (
                        <span>{dateformat(item?.create_so_sap_date)}</span>
                      )}
                    </td>
                    <td>
                      <PopoverText
                        content={item?.product_types ? item?.product_types : '-'}
                        index={_index}
                        className='desc-slice'
                      />
                    </td>
                    <td>
                      <span>
                        {(i18next.language === 'en'
                          ? parseFloat(item.detail_quantity?.total_tonnase)?.toLocaleString('en', {
                              maximumFractionDigits: 4,
                            })
                          : parseFloat(item.detail_quantity?.total_tonnase)?.toLocaleString('id', {
                              maximumFractionDigits: 4,
                            })) + (item.sector_id != 3 ? ' Ton' : ' MT')}
                      </span>
                    </td>
                    <td>
                      <span>
                        {(item.sector_id == 3 ? 'USD' : 'Rp') + i18next.language === 'en'
                          ? item.price_after_ppn?.toLocaleString('en', {maximumFractionDigits: 4})
                          : item.price_after_ppn?.toLocaleString('id', {maximumFractionDigits: 4})}
                      </span>
                    </td>
                    <td>
                      <span>
                        <PopoverText
                          content={item?.payment?.payment_desc ? item?.payment?.payment_desc : '-'}
                          index={_index}
                          className='desc-slice'
                        />
                      </span>
                    </td>
                    <td>
                      <BadgeColorSO text={item.status_text} status={item.status} role={roleUser} />
                    </td>
                    <td>
                      <div
                        className='d-flex p-0 justify-content-center'
                        style={{marginTop: '1.3px', marginBottom: '1px'}}
                      >
                        {hakAkses?.approve && (
                          <button
                            onClick={() => goToDetail(item['id'])}
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            title='Detail'
                          >
                            <KTSVG
                              path='/media/icons/duotune/file-text-fill.svg'
                              className='svg-icon-3'
                            />
                          </button>
                        )}
                        <button
                          onClick={() => {
                            ambilAttachment(item.id, 'sales-order')
                            setParam('sales-order')
                            setIDItem(item.id)
                            setShowUpload(true)
                          }}
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2'
                          title={t('order-lampiran')}
                        >
                          <KTSVG
                            path='/media/icons/duotune/archive-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>
                        {hakAkses?.print && item.sap_number != null && (
                          <button
                            onClick={() =>
                              handleCheckFile(
                                `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/sales-order/print/proforma-invoice/${item.id}?lang=${i18next.language}`
                              )
                            }
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            title={t('print')}
                          >
                            <KTSVG
                              path='/media/icons/duotune/printer-fill.svg'
                              className='svg-icon-3'
                            />
                          </button>
                        )}
                        <button
                          onClick={() => {
                            handleGetComment(item.id)
                          }}
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                          title={t('Comment')}
                        >
                          <KTSVG
                            path='/media/icons/duotune/chat-left-text-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>
                      </div>
                    </td>
                  </tr>

                  <tr className='fold' id={'target' + item['id']}>
                    <TableUI.TableDetail colSpan={16}>
                      <TableUI.TableWrapper style={{marginBottom: 0}}>
                        <TableUI.Table>
                          <TableUI.THead>
                            <tr style={{backgroundColor: '#274070'}}>
                              <th>{t('kontrak-item')}</th>
                              <th>Sales Org</th>
                              <th>{t('kontrak-incoterm')}</th>
                              <th>{t('kontrak-wilayah')}</th>
                              <th>{t('kontrak-jenis')}</th>
                              <th>{t('Product Code')}</th>
                              <th>{t('kontrak-nama')}</th>
                              <th>{t('quantumapproved')}</th>
                              {item.sector_id !== 2 && <th>{t('Shipping Tolerance')}</th>}
                              <th>{t('quantumso')}</th>
                              <th>{t('quantumsisa')}</th>
                              <th>{t('quantumrealized')}</th>
                              <th>{t('Price')}</th>
                              <th>{t('kontrak-hargaPPN')}</th>
                              <th>{t('kontrak-ppn')}</th>
                              <th>{t('kontrak-hargaSPPN')}</th>
                              <th>{t('Plant')}</th>
                              <th>{t('Route')}</th>
                              <th>Status</th>
                              <th>{t('order-aksi')}</th>
                            </tr>
                          </TableUI.THead>
                          <TableUI.TBody>
                            {item['so_items']?.map((subItem: any, index: number) => (
                              <tr key={subItem?.id ?? index}>
                                <td>{index + 1}</td>
                                <td>{subItem.order_sub_detail?.produsen?.name}</td>
                                {subItem.order_sub_detail?.sector?.id == 2 ? (
                                  <td>
                                    {subItem?.incoterm1?.code}{' '}
                                    {subItem?.incoterm2 == null ? '' : '-' + subItem?.incoterm2}
                                  </td>
                                ) : (
                                  <>
                                    {subItem?.incoterm2 == null ? (
                                      <td>
                                        {subItem?.incoterm1?.code}
                                        {subItem?.incoterm2 == null || subItem?.incoterm2 == '0'
                                          ? ''
                                          : '-' + subItem?.incoterm2}
                                      </td>
                                    ) : (
                                      <td>
                                        {subItem?.incoterm1?.code}-{subItem?.incoterm2}
                                      </td>
                                    )}
                                  </>
                                )}
                                <td>
                                  {subItem.order_sub_detail?.province?.region_name}
                                  {subItem.order_sub_detail?.city?.city_name
                                    ? ', ' + subItem.order_sub_detail?.city?.city_name
                                    : ''}
                                </td>

                                <td>{subItem.order_sub_detail?.product_type_desc}</td>
                                <td>
                                  {parseInt(subItem.order_sub_detail?.material_number) == 0
                                    ? ''
                                    : subItem.order_sub_detail?.material_number?.slice(-7)}
                                </td>
                                <td>{subItem.order_sub_detail?.product_name}</td>
                                <td>
                                  {i18next.language === 'en'
                                    ? subItem?.order_sub_detail?.fixed_quantum?.toLocaleString(
                                        'en',
                                        {maximumFractionDigits: 4}
                                      )
                                    : subItem?.order_sub_detail?.fixed_quantum?.toLocaleString(
                                        'id',
                                        {maximumFractionDigits: 4}
                                      )}{' '}
                                  {subItem.order_sub_detail?.product_type != '8105'
                                    ? subItem.sector_id === 3
                                      ? 'MT'
                                      : 'Ton'
                                    : subItem.order_sub_detail?.unit}
                                </td>
                                {item.sector_id != 2 ? (
                                  <td>{subItem.order_sub_detail?.shipping_tolerance}%</td>
                                ) : (
                                  ''
                                )}
                                <td>
                                  {i18next.language === 'en'
                                    ? subItem?.quantity?.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : subItem?.quantity?.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })}{' '}
                                  {subItem.order_sub_detail?.product_type != '8105'
                                    ? subItem.sector_id === 3
                                      ? 'MT'
                                      : 'Ton'
                                    : subItem.order_sub_detail?.unit}
                                </td>
                                <td>
                                  {i18next.language === 'en'
                                    ? subItem?.order_sub_detail?.left_over_quantum_no_st?.toLocaleString(
                                        'en',
                                        {maximumFractionDigits: 4}
                                      )
                                    : subItem?.order_sub_detail?.left_over_quantum_no_st?.toLocaleString(
                                        'id',
                                        {maximumFractionDigits: 4}
                                      )}{' '}
                                  {subItem.order_sub_detail?.product_type != '8105'
                                    ? subItem.sector_id === 3
                                      ? 'MT'
                                      : 'Ton'
                                    : subItem.order_sub_detail?.unit}
                                </td>
                                <td>
                                  {i18next.language === 'en'
                                    ? subItem?.order_sub_detail?.so_qty_realized?.toLocaleString(
                                        'en',
                                        {maximumFractionDigits: 4}
                                      )
                                    : subItem?.order_sub_detail?.so_qty_realized?.toLocaleString(
                                        'id',
                                        {maximumFractionDigits: 4}
                                      )}{' '}
                                  {subItem.order_sub_detail?.product_type != '8105'
                                    ? subItem.sector_id === 3
                                      ? 'MT'
                                      : 'Ton'
                                    : subItem.order_sub_detail?.unit}
                                </td>
                                <td>
                                  {item.sector_id == 3 ? 'USD' : 'Rp'}
                                  {subItem.price == 0 || subItem.price == null ? (
                                    <>
                                      {i18next.language === 'en'
                                        ? subItem?.order_sub_detail?.fixed_price?.toLocaleString(
                                            'en',
                                            {maximumFractionDigits: 4}
                                          )
                                        : subItem?.order_sub_detail?.fixed_price?.toLocaleString(
                                            'id',
                                            {maximumFractionDigits: 4}
                                          )}
                                    </>
                                  ) : (
                                    <>
                                      {i18next.language === 'en'
                                        ? subItem?.price?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : subItem?.price?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })}
                                    </>
                                  )}
                                  /
                                  {subItem.order_sub_detail?.product_type != '8105'
                                    ? item.sector_id == 3
                                      ? 'MT'
                                      : 'Ton'
                                    : subItem.order_sub_detail?.unit}
                                </td>
                                <td>
                                  {(item.sector_id == 3 ? 'USD' : 'Rp') + i18next.language === 'en'
                                    ? subItem.price_before_ppn?.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : subItem.price_before_ppn?.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })}
                                </td>
                                <td>{subItem.ppn}%</td>
                                <td>
                                  {(item.sector_id == 3 ? 'USD' : 'Rp') + i18next.language === 'en'
                                    ? subItem.price_after_ppn?.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : subItem.price_after_ppn?.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })}
                                </td>
                                <td>{subItem.plant_desc}</td>
                                <td>{subItem.route_desc}</td>
                                <td>
                                  <BadgeColorSO
                                    text={subItem.status_text}
                                    status={subItem.status}
                                    role={roleUser}
                                  />
                                </td>
                                <td>
                                  <div className='d-flex justify-content-center align-items-center'>
                                    <button
                                      onClick={() => {
                                        setTempDetail(subItem)
                                        setShowDetail(true)
                                      }}
                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                      title='Detail'
                                    >
                                      <KTSVG
                                        path='/media/icons/duotune/file-text-fill.svg'
                                        className='svg-icon-3'
                                      />
                                    </button>
                                    <button
                                      onClick={() => {
                                        setFileBox(subItem.order_sub_detail)
                                        ambilAttachment(subItem?.id, 'so-item')
                                        setSektorId(subItem.order_sub_detail.sector_id)
                                        setParam('so-item')
                                        setSONumber(item.so_number)
                                        setIDItem(subItem?.id)
                                        setShowUpload(true)
                                      }}
                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-1 me-1'
                                      title={t('order-lampiran')}
                                    >
                                      <KTSVG
                                        path='/media/icons/duotune/archive-fill.svg'
                                        className='svg-icon-3'
                                      />
                                    </button>
                                    {item.order_sub.regarding == 'PO001' ? (
                                      <button
                                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-1 me-1'
                                        title={t('Jadwal')}
                                        onClick={() => {
                                          setSektorId(subItem.order_sub_detail.sector_id)
                                          setProvinceName(
                                            subItem.order_sub_detail.province?.region_name
                                          )
                                          setTipeProduct(subItem.order_sub_detail.product_type)
                                          setUnitProduct(subItem.order_sub_detail.unit)
                                          setCityName(subItem.order_sub_detail.city?.city_name)
                                          setProductName(subItem.order_sub_detail.product_name)
                                          formattingTon(subItem.order_sub_detail.fixed_quantum)
                                          setOrderSubID(
                                            subItem.order_sub_detail.order_sub_item_id == null
                                              ? subItem?.order_sub_detail?.id
                                              : subItem?.order_sub_detail?.order_sub_item_id
                                          )
                                          setShowJadwal(true)
                                        }}
                                      >
                                        <KTSVG
                                          path='/media/icons/duotune/calendar-check-fill.svg'
                                          className='svg-icon-3'
                                        />
                                      </button>
                                    ) : (
                                      ''
                                    )}
                                    <DocFlow
                                      id={
                                        subItem.order_sub_detail.order_sub_item_id == null
                                          ? subItem?.order_sub_detail.id
                                          : subItem?.order_sub_detail.order_sub_item_id
                                      }
                                    />
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </TableUI.TBody>
                        </TableUI.Table>
                      </TableUI.TableWrapper>
                    </TableUI.TableDetail>
                  </tr>
                </>
              ))
            )}
          </TableUI.TBody>
        </TableUI.Table>
      </TableUI.TableWrapper>

      <Pagination paginate={paginateNumber} test={numberURL} />

      <Modal
        size='lg'
        show={showUpload}
        onHide={() => {
          setAllFiles([])
          setShowUpload(false)
          setIsPrivate(false)
          setTempRole([])
          setFileBox({})
        }}
        backdrop='static'
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {fileBox?.product_name
              ? (fileBox.province ? fileBox.province?.region_name : '') +
                (fileBox.city ? ', ' + fileBox.city?.city_name : '') +
                (fileBox.province ? ' | ' : '') +
                fileBox.product_name +
                (fileBox.request_quantum ? ' | ' + fileBox.request_quantum + ' Ton' : '')
              : t('File Box')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col sm={6}>
              <table className='mb-3'>
                <tr>
                  <td style={{width: '120px'}}>
                    <h6>{t('order-fileUnggah')}</h6>
                  </td>
                  <td className='w-75'>
                    <InputFile
                        setFileName={setNamaFile}
                        setFiles={setFiles}
                        isBase64={false}
                    />
                  </td>
                </tr>
              </table>
              <table className='mb-3'>
                <tr>
                  <td style={{width: '120px'}}>
                    <h6>{t('order-keterangan')}</h6>
                  </td>
                  <td className='w-75'>
                    <Form.Control
                      type='text'
                      placeholder={t('order-keterangan')}
                      onChange={(e: any) => setDescription(e.target.value)}
                      value={description}
                    />
                  </td>
                </tr>
              </table>
              <table
                className='mb-3'
                hidden={roleUser == 'null' || roleUser == null ? true : false}
              >
                <tr>
                  <td>
                    <h6 className='me-11'>{t('Private')}</h6>
                  </td>
                  <td className='w-75 d-flex justify-content-start'>
                    <Form.Check
                      reverse
                      name='isPrivate'
                      type='checkbox'
                      className='mt-5 mb-2'
                      onClick={() => {
                        setIsPrivate(!isPrivate)
                        setTempRole([])
                      }}
                      id='isPrivate'
                    />
                  </td>
                </tr>
              </table>
              <table className='mb-3' hidden={isPrivate ? false : true}>
                <tr>
                  <td style={{width: '120px'}}>
                    <h6>{t('Akses Role')}</h6>
                  </td>
                  <td className='w-75' style={{maxWidth: '274px'}}>
                    <MultiSelect
                      key={isPrivate.toString()}
                      options={fullRole?.map((item: any) => {
                        return {label: item.label, value: item.value}
                      })}
                      value={tempRole}
                      onChange={(e: any) => setTempRole(e)}
                      labelledBy='Select'
                    />
                  </td>
                </tr>
              </table>
              <Button
                variant='primary'
                className='w-100'
                disabled={btnLoading}
                onClick={() => handleUpload(idItem)}
              >
                {btnLoading ? (
                  <Spinner animation='border' variant='light' size='sm' />
                ) : (
                  t('order-kirim')
                )}
              </Button>
            </Col>
          </Row>
          <div className='table-responsive mt-4 bdr' style={{marginTop: '3rem'}}>
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <thead className='border-bottom fw-bold'>
                <tr className=''>
                  <th className='text-center'>{t('order-noo')}</th>
                  <th className='text-center'>{t('order-keterangan')}</th>
                  <th className='text-center'>{t('order-tglUpload')}</th>
                  {/* <th className='text-center'>{t('User Code')}</th> */}
                  <th className='text-center'>{t('order-user')}</th>
                  <th className='text-center'>{t('Akses Role')}</th>
                  <th className='text-center'>{t('order-aksi')}</th>
                </tr>
              </thead>
              {allFile.map((data: any, _index: number) => (
                <tbody key={data?.id ?? _index}>
                  <tr className=''>
                    <td className='text-center'>
                      <label>{_index + 1}</label>
                    </td>
                    <td className='text-center'>
                      <label>{data.description}</label>
                    </td>
                    <td className='text-center'>
                      <label>{dateformat(data.updated_at)}</label>
                    </td>
                    {/* <td className='text-center'>
                      <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                    </td> */}
                    <td className='text-center'>
                      {data.user?.customer != null ? (
                        <label>{data.user?.customer?.name}</label>
                      ) : (
                        <label>{data.user?.name}</label>
                      )}
                    </td>
                    <td className='text-center'>
                      {data.private ? (
                        data.roles.length > 0 ? (
                          <PopoverText
                            content={handleShowRoleName(data.roles)}
                            index={_index}
                            className='desc-slice'
                          />
                        ) : (
                          'Private'
                        )
                      ) : (
                        'Public'
                      )}
                    </td>
                    <td className='text-center'>
                      <button
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title={t('unduh')}
                        onClick={() =>
                          handleDownloadAttachment(data.file_path)
                        }
                      >
                        <KTSVG
                          path='/media/icons/duotune/arrow-down-square-fill.svg'
                          className='svg-icon-3'
                        />
                      </button>
                      {(hakAkses?.attachment_delete ||
                        CheckSameIDAttachment(data.user_role_flag)) && (
                        <button
                          onClick={() => deleteAttachment(data.id)}
                          className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm`}
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('Hapus')}
                        >
                          <KTSVG
                            path='/media/icons/duotune/trash-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>
                      )}
                    </td>
                  </tr>
                </tbody>
              ))}
            </table>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showJadwal}
        onHide={() => setShowJadwal(false)}
        centered
        size='xl'
        backdrop='static'
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {sektorId != 3 ? provinceName + ', ' + cityName + ' | ' : ''}
            {productName} | {fixedQuantum} {tipeProduct != '8105' ? 'Ton' : unitProduct}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span style={{fontSize: '15px'}} className='fw-bold d-block'>
            {t('Jadwal')}
          </span>
          <AddRemoveJadwal id={orderSubID} is_amendment={'false'} tipeproduct={tipeProduct} unit={unitProduct}/>
        </Modal.Body>
      </Modal>

      <Modal
        show={showCommentCust}
        onHide={() => setShowCommentCust(false)}
        centered
        backdrop='static'
        size='lg'
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Comment')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {fullcomment?.length < 1 ? (
            <div>{t('No Comment')}</div>
          ) : (
            <div className='table-responsive mt-10 bdr'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bold w-100 align-items-center'>
                    <th className='td-3 text-center'>{t('no')}</th>
                    <th className='td-3 text-center'>{t('order-tanggal')}</th>
                    <th className='td-3 text-center'>{t('order-user')}</th>
                    <th className='td-3 text-center'>{t('Comment')}</th>
                  </tr>
                </thead>
                {fullcomment?.map((item: any, _index: number) => (
                  <tbody key={item?.id ?? _index}>
                    <tr className='w-100 align-items-center'>
                      <td className='td-150 text-center'>{_index + 1}</td>
                      <td className='td-150 text-center'>{item.created_at?.slice(0, 10)}</td>
                      <td className='td-150 text-center'>{item.user?.name}</td>
                      <td className='td-60 text-center text-truncate'>
                        <PopoverText content={item.comment} index={_index} className='desc-slice' />
                      </td>
                    </tr>
                  </tbody>
                ))}
              </table>
              {/* End Table Head */}
            </div>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        show={showDetail}
        onHide={() => {
          setShowDetail(false)
        }}
        centered
        scrollable
        backdrop='static'
        size={'xl'}
      >
        <Modal.Header closeButton>
          <Modal.Title>Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md='6'>
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='mt-3 fs-6'>Sales Org</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={tempDetail?.order_sub_detail?.produsen?.name}
                    type='text'
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={tempDetail?.order_sub_detail?.incoterm1?.code}
                    type='text'
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col sm={4}>
                  <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                </Col>
                <Col sm={8}>
                  <Form.Control
                    type='text'
                    size='sm'
                    value={tempDetail?.order_sub_detail?.province?.region_name}
                    disabled
                  />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={tempDetail?.order_sub_detail?.product_type_desc}
                    type='text'
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={
                      (i18next.language === 'en'
                        ? parseFloat(tempDetail.quantity).toLocaleString('en', {
                            maximumFractionDigits: 4,
                          })
                        : parseFloat(tempDetail.quantity).toLocaleString('id', {
                            maximumFractionDigits: 4,
                          })) + (tempDetail.sector_id === 3 ? 'MT' : 'Ton')
                    }
                    type='text'
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col sm={4} className='d-flex align-items-center'>
                  <p className='fs-6'>{t('Shipping Tolerance')}</p>
                </Col>
                <Col sm={8}>
                  <Form.Control
                    // placeholder={t('Shipping Tolerance')}
                    size='sm'
                    type='text'
                    id='shipping'
                    value={
                      tempDetail?.order_sub_detail?.shipping_tolerance == 0
                        ? ''
                        : tempDetail?.order_sub_detail?.shipping_tolerance + '%'
                    }
                    disabled
                  />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={tempDetail?.order_sub_detail?.payment_type_1_desc}
                    type='text'
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={4} className='d-flex align-items-center'>
                  <p className='fs-6'>{t('keterangan')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={t(tempDetail?.order_sub_detail?.payment_note)}
                    type='text'
                    as='textarea'
                    style={{height: '40px'}}
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='mt-3 fs-6'>{t('End Customer')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={
                      tempDetail?.order_sub_detail?.end_user_multiple
                        ? handleShowValue(tempDetail?.order_sub_detail?.end_user)
                        : tempDetail?.order_sub_detail?.end_user
                    }
                    as='textarea'
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
            </Col>
            <Col md='6'>
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={t(tempDetail?.order_sub_detail?.sector?.name)}
                    type='text'
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                </Col>
                <Col md={8}>
                  {tempDetail?.order_sub_detail?.incoterm2 == null ? (
                    <Form.Control
                      value={
                        tempDetail?.order_sub_detail?.incoterm2_id == null ||
                        tempDetail?.order_sub_detail?.incoterm2_id == '0'
                          ? ''
                          : tempDetail?.order_sub_detail?.incoterm2_id
                      }
                      type='text'
                      disabled
                      size='sm'
                    />
                  ) : (
                    <Form.Control
                      value={tempDetail?.order_sub_detail?.incoterm2?.code}
                      type='text'
                      disabled
                      size='sm'
                    />
                  )}
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    type='text'
                    value={tempDetail?.order_sub_detail?.city?.city_name}
                    size='sm'
                    disabled
                  />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={tempDetail?.order_sub_detail?.product_name}
                    type='text'
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='fs-6 mt-3'>
                    {t('Harga Pengajuan')}/{tempDetail.sector_id === 3 ? 'MT' : 'Ton'}
                  </p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={
                      (tempDetail?.order_sub_detail?.sector_id === 3 ? 'USD' : 'Rp') +
                      PriceFormater(tempDetail?.order_sub_detail?.fixed_price)
                    }
                    type='text'
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={4} className='d-flex align-items-center'>
                  <p className='fs-6'>{t('sub-order-spek')}</p>
                </Col>
                <Col md={8}>
                  <FieldProductSpec
                    data={tempDetail?.product_spec || tempDetail?.order_sub_detail?.product_spec}
                    type='editor'
                  />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={tempDetail?.order_sub_detail?.payment_type_2_desc}
                    type='text'
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              <Row
                className='mb-4'
                hidden={tempDetail?.order_sub_detail?.sector_id == 3 ? true : false}
              >
                <Col md={4}>
                  <p className='fs-6 mt-3'>{t('segment')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={t(tempDetail?.order_sub_detail?.segment_name)}
                    type='text'
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={4}>
                  <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={tempDetail?.order_sub_detail?.notes}
                    type='text'
                    as='textarea'
                    style={{height: '40px'}}
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </StyledCard>
  )
}

export {ApprovalTableSO}
